module.exports = __webpack_public_path__ + "static/img/video-pass.969dc31b.png";